import { Box, Rating, Typography } from '@mui/material';
import React from 'react';
import { RATING } from '../utils/constants';

export const StarRating = ({ formData, handleChange }) => {
  function valueText(value) {
    return `${RATING[value - 1]}`;
  }

  const sections = [
    { id: 'consultationSatisfaction', label: 'Consultation Satisfaction' },
    { id: 'comfortPreparedness', label: 'Comfort and Preparedness' },
    { id: 'professionalismCare', label: 'Professionalism and Care' },
    { id: 'painDiscomfort', label: 'Pain and Discomfort' },
    { id: 'communication', label: 'Communication' },
    { id: 'satisfactionResults', label: 'Satisfaction with Results' },
    { id: 'recommendationLikelihood', label: 'Recommendation Likelihood' },
  ];

  return sections.map((section) => (
    <Box
      key={section.id}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignContent: 'center',
        alignItems: 'center',
        mt: 2,
      }}
    >
      <Typography id={`${section.id}Label`} variant={'button'}>
        {section.label}
      </Typography>

      <Box key={section.id}>
        <Rating
          precision={1}
          value={formData[section.id]}
          onChange={handleChange}
          name={section.id}
          getLabelText={valueText}
          max={5}
          size={'large'}
        />
        <Box sx={{ ml: 2, fontWeight: 300, fontSize: 10 }}>
          {valueText(formData[section.id])}
        </Box>
      </Box>
    </Box>
  ));
};
